import { render, staticRenderFns } from "./LayoutSection.vue?vue&type=template&id=c3994b0c&scoped=true&"
import script from "./LayoutSection.vue?vue&type=script&lang=ts&"
export * from "./LayoutSection.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutSection.vue?vue&type=style&index=0&id=c3994b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3994b0c",
  null
  
)

export default component.exports